import i18n from '@/lang/i18n'
import CheckIcon from '@/cellRenderers/common/CheckIcon'

export default function() {
    return [
        { type: 'customCheckbox' },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.name'),
            field: 'name',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.middleName'),
            field: 'middleName',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.surname1'),
            field: 'surname1',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.surname2'),
            field: 'surname2',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.email'),
            field: 'contactInformation.email',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.phone'),
            field: 'contactInformation.mainPhone',
            flex: 1
        },
        {
            type: 'text',
            headerName: i18n.t('configuration.grid.externalCode'),
            field: 'code',
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.physician'),
            field: 'isPhysician',
            minWidth: 100,
            flex: 1
        },
        {
            type: 'checkIconRenderer',
            headerName: i18n.t('configuration.grid.active'),
            field: 'active',
            minWidth: 100,
            flex: 1
        },
        {
            headerName: i18n.t('configuration.grid.user'),
            field: 'user',
            minWidth: 100,
            cellRendererFramework: CheckIcon,
            sortable: false,
            filter: false,
            flex: 1
        }
    ]
}
